import PerfectScrollbar from "perfect-scrollbar";

let PluginScrollbar = new function(){
    let me = this;

    this.init = function(obj){
        obj.find('[data-plugin-scrollbar]').each(function (){
            new PerfectScrollbar($(this)[0]);
        });
    };
};

export default PluginScrollbar;
